export default __webpack_public_path__ + "static/client-back-f6ee079c8cd1690db95d7c3c3d2e4187.webp";